import fetcher from "../helpers/fetcher";

export async function GetAllLocations(
  page,
  searchTerm = "",
  fetchAll = false,
  withCoordinates = false,
  partnerId = ""
) {
  let path = `/locations?page=${page}&search=${searchTerm}&fetchAll=${fetchAll}&withCoordinates=${withCoordinates}&partnerId=${partnerId}`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function FindParentLocations() {
  let path = `/locations/parents`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function CreateLocation(body, partnerId) {
  let path = `/locations?partnerId=${partnerId}`;
  let request = await fetcher(path, "POST", body);
  let content = await request.json();
  return content;
}

export async function GetLocationByID(id) {
  let path = `/locations/${id}`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function GetLocationInfo(id) {
  let path = `/locations/${id}/details`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function SaveLocationInfo(body, id) {
  let path = `/locations/${id}`;
  let request = await fetcher(path, "PUT", body);
  let content = await request.json();
  return content;
}

export async function DeleteLocation(id) {
  let path = `/locations/${id}`;
  let request = await fetcher(path, "DELETE");
  let content = await request.json();
  return content;
}

export async function ExportLocationsToExcel(partnerId) {
  const token = localStorage.getItem("token");

  const url = `${process.env.REACT_APP_REQUEST_URL}/locations/export?partnerId=${partnerId}&export=excel`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to download Excel file");
  }

  const blob = await response.blob();
  const filename = response.headers.get("File-Name") || "locations_export.xlsx";

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function GenerateLocationPlaylist(id) {
  let path = `/locations/${id}/generate-playlist`;
  let request = await fetcher(path, "POST");
  let content = await request.json();
  return content;
}

export async function GetAllCounties() {
  let path = `/loops/counties`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function GetAllCities() {
  let path = `/loops/cities`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}
